export default __webpack_public_path__ + "e34f21de57fa3ac676e7b0919caf1e8a.jpg";